'use strict';
(function () {
  angular.module('pentaApp').factory('customInquery.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/customInquery', null, { detail: { isArray: false, cache: false } });
  }
})();
